import { useEffect } from "react"

import { useMatch } from "react-router-dom"

import { FullscreenIcon, FullscreenExitIcon, CloseIcon } from "@l2r-front/l2r-icons"
import { useMapContext } from "@l2r-front/l2r-map"
import { PropTypes } from "@l2r-front/l2r-proptypes"
import { useIsMobileDevice } from "@l2r-front/l2r-ui"

import { useImageCollectionDispatchContext } from "../../contexts/ImageCollectionContext"

import { ImageViewer } from "../ImageViewer"

import * as Styled from "./ImageViewerContainer.styled"

export const ImageViewerContainer = (props) => {

    const { className } = props
    const [state, dispatch] = useMapContext()
    const { mapHeightPct } = state
    const { setMapHeightPct } = dispatch
    const { resetImageCollectionDisplay, setDisplayedImagePosition } = useImageCollectionDispatchContext()
    const match = useMatch(":networkID/:module/:submodule/:road/*")
    const isMobile = useIsMobileDevice()

    useEffect(() => {
        if (!match?.params?.road) {
            setMapHeightPct(100)
        }
    }, [match, setMapHeightPct])

    return (
        <ImageViewer
            className={className}
            bottomRightComponent={mapHeightPct !== 100 && <Styled.IconButton
                color="primary"
                isMobile={isMobile}
                onClick={() => setMapHeightPct(mapHeightPct === 50 ? 0 : 50)}
            >
                {mapHeightPct === 50 ? <FullscreenIcon /> : <FullscreenExitIcon />}
            </Styled.IconButton >}
            topRightComponent={mapHeightPct !== 100 && <Styled.CloseIconButton
                color="primary"
                isMobile={isMobile}
                onClick={() => {
                    resetImageCollectionDisplay()
                    setDisplayedImagePosition(null)
                    setMapHeightPct(100)
                }}
            >
                <CloseIcon />
            </Styled.CloseIconButton>} />
    )
}

ImageViewerContainer.propTypes = {
    className: PropTypes.string,
}